import React from 'react'
import Button from '@material-ui/core/Button'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import { SelectedFilters } from './SelectedFilters'
import { indextypes, regions, states } from '../../constants/Filter'

import './selected-filters.css'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    clearButton: {
      width: 100,
      height: 32,
      border: '1px solid #C313A7',
      textTransform: 'unset',
      fontFamily: 'Quicksand',
      fontSize: 12,
      fontWeight: 500,
      lineHeight: 12,
      color: '#C313A7',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  }),
)

interface SelectedFiltersBarProps {
  selectedStates: string[]
  setState: React.Dispatch<React.SetStateAction<string[]>>
  selectedRegions: string[]
  setRegion: React.Dispatch<React.SetStateAction<string[]>>
  selectedIndexTypes: string[]
  setIndexType: React.Dispatch<React.SetStateAction<string[]>>
  clearFilters: () => void
}

export const SelectedFiltersBar: React.FC<SelectedFiltersBarProps> = ({
  selectedStates,
  setState,
  selectedRegions,
  setRegion,
  selectedIndexTypes,
  setIndexType,
  clearFilters,
}) => {
  const classes = useStyles()
  const displayBar: boolean =
    selectedStates.length > 1 ||
    selectedRegions.length > 1 ||
    selectedIndexTypes.length > 1 ||
    (selectedStates.length === 1 && selectedStates[0] !== states[0].value) ||
    (selectedRegions.length === 1 && selectedRegions[0] !== regions[0].value) ||
    (selectedIndexTypes.length === 1 && selectedIndexTypes[0] !== indextypes[0].value)

  return (
    <div data-testid="test-filter-bar" className={`selected-filter-bar ${!displayBar && 'hidden'}`}>
      <SelectedFilters setFilter={setState} selectedFilter={selectedStates} filterConstants={states} />
      <SelectedFilters setFilter={setRegion} selectedFilter={selectedRegions} filterConstants={regions} />
      <SelectedFilters setFilter={setIndexType} selectedFilter={selectedIndexTypes} filterConstants={indextypes} />
      {displayBar && (
        <Button className={classes.clearButton} onClick={clearFilters}>
          Clear Filters
        </Button>
      )}
    </div>
  )
}

export default SelectedFiltersBar
